var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _Logos = require("../Basic/Logos");

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _Basic = require("../../../elements/Basic");

var _TransferComponents = require("./TransferComponents");

var _PlayerName = _interopRequireDefault(require("../Basic/PlayerName"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Transfers/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Transfer = function (_React$Component) {
  (0, _inherits2.default)(Transfer, _React$Component);

  var _super = _createSuper(Transfer);

  function Transfer() {
    var _this;

    (0, _classCallCheck2.default)(this, Transfer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getColorForTransfer = function (teamId, transfer) {
      if (!teamId) {
        return 'transfer.standard';
      } else if ((0, _get.default)(transfer, 'player.team.id') === teamId) {
        return 'transfer.joining';
      }

      return 'transfer.leaving';
    };

    return _this;
  }

  (0, _createClass2.default)(Transfer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          teamId = _this$props.teamId,
          transfer = _this$props.transfer,
          _onPress = _this$props.onPress,
          href = _this$props.href,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["teamId", "transfer", "onPress", "href", "NavWrapper"]);
      return transfer && transfer.player ? _react.default.createElement(_Touchable.default, {
        onPress: function onPress() {
          return _onPress(transfer.player);
        },
        href: href,
        NavWrapper: NavWrapper,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.Row, (0, _extends2.default)({}, rest, {
        center: true,
        mb: 2,
        p: 2,
        borderX: 1,
        borderY: 1,
        borderColor: "border.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34,
          columnNumber: 17
        }
      }), _react.default.createElement(_Logos.CircleLogo, {
        size: 40,
        src: transfer.player.imageUrl,
        imageType: "player",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 21
        }
      }), _react.default.createElement(_Basic.Column, {
        flexing: true,
        ml: 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.Row, {
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 25
        }
      }, _react.default.createElement(_PlayerName.default, {
        bold: true,
        grow: true,
        player: transfer.player,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46,
          columnNumber: 29
        }
      }), _react.default.createElement(_TransferComponents.PlayerLoan, {
        loan: transfer.loan,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47,
          columnNumber: 29
        }
      })), _react.default.createElement(_Basic.Row, {
        centerHorizontal: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 25
        }
      }, _react.default.createElement(_TransferComponents.TeamLabel, {
        doFallback: true,
        maxWidth: "40%",
        team: transfer.previousTeam,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 29
        }
      }), _react.default.createElement(_FontelloIcon.default, {
        mx: 2,
        name: "transfer",
        size: 14,
        color: this.getColorForTransfer(teamId, transfer),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 29
        }
      }), _react.default.createElement(_TransferComponents.TeamLabel, {
        doFallback: true,
        mr: 2,
        team: transfer.player.team,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 29
        }
      }), _react.default.createElement(_TransferComponents.PlayerJoinDate, {
        joinDate: transfer.joinDate,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 29
        }
      }))))) : null;
    }
  }]);
  return Transfer;
}(_react.default.Component);

Transfer.propTypes = {
  teamId: _propTypes.default.string,
  transfer: _propTypes.default.object.isRequired,
  onPress: _propTypes.default.func,
  NavWrapper: _propTypes.default.func,
  href: _propTypes.default.string
};
var _default = Transfer;
exports.default = _default;